(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    


document.addEventListener("DOMContentLoaded", (event) => {
  const header = document.querySelector('.header-wrapper');
  if( header){
       document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }
});




  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      window.addEventListener('scroll', this.onScroll.bind(this), false);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.header.offsetHeight ) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      } 
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
